import { render, staticRenderFns } from "./HandsOnTable.vue?vue&type=template&id=34fe691b&scoped=true"
import script from "./HandsOnTable.vue?vue&type=script&lang=js"
export * from "./HandsOnTable.vue?vue&type=script&lang=js"
import style0 from "../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./HandsOnTable.vue?vue&type=style&index=1&id=34fe691b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe691b",
  null
  
)

export default component.exports